import { FilterCategory, FilterKey, FiltersCollection } from '../../types';

export const FILTER_CATEGORY_BY_KEY: Record<FilterKey, FilterCategory> = {
  languages: 'language',
  areasOfExpertise: 'areaOfExpertise',
  approaches: 'approach',
  genders: 'gender',
  ethnicities: 'ethnicity',
};

/**
 * Keeps the applied filter keys ordered by when a value was last added to them,
 * so the most recently added filter is last.
 */
export const updateFilterKeyOrder = (
  order: FilterKey[],
  previousFilters: FiltersCollection,
  nextFilters: FiltersCollection,
): FilterKey[] => {
  const addedKeys = (Object.keys(nextFilters) as FilterKey[]).filter(
    key => nextFilters[key].length > previousFilters[key].length,
  );

  return [
    ...order.filter(key => !addedKeys.includes(key)),
    ...addedKeys,
  ].filter(key => nextFilters[key].length > 0);
};
